// extracted by mini-css-extract-plugin
export var baseTiming = "125ms";
export var baseTimingInt = "125";
export var borderRadius = "3px";
export var charcoal = "#2d2e2e";
export var cloudGrey = "#c8cdcf";
export var disabled = "LoadingSpinner-module__disabled--Z28gB";
export var doveGrey = "#f1f3f5";
export var error = "LoadingSpinner-module__error--1hNUV";
export var khBlue = "#04b1e0";
export var khBlueDark = "#0376ae";
export var khBlueLight = "#7de1f4";
export var large = "LoadingSpinner-module__large--3ImMz";
export var lemon = "#fae436";
export var lemonDark = "#e3cd02";
export var lemonLight = "#fff284";
export var lime = "#05c150";
export var limeDark = "#068230";
export var limeLight = "#65ec83";
export var navy = "#052976";
export var navyDark = "#04173f";
export var navyLight = "#82b1f6";
export var primary = "LoadingSpinner-module__primary--33hG8";
export var scarlet = "#e9062b";
export var scarletDark = "#9d050e";
export var scarletLight = "#f5726d";
export var secondary = "LoadingSpinner-module__secondary--1fwXF";
export var small = "LoadingSpinner-module__small--2rIrs";
export var spin = "LoadingSpinner-module__spin--385ZQ";
export var spinner = "LoadingSpinner-module__spinner--1rWkN";
export var stormGrey = "#969b9c";
export var text = "LoadingSpinner-module__text--2zedF";
export var violet = "#d401f8";
export var violetDark = "#9003a8";
export var violetLight = "#e77ef9";
export var white = "#fff";